var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1082 7.89169L7.8916 12.1083C7.34994 11.5667 7.0166 10.825 7.0166 9.99999C7.0166 8.34999 8.3499 7.01669 9.9999 7.01669C10.8249 7.01669 11.5666 7.35003 12.1082 7.89169Z",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8499 4.80832C13.3916 3.70832 11.7249 3.10832 9.99989 3.10832C7.0582 3.10832 4.31654 4.84166 2.4082 7.84166C1.6582 9.01667 1.6582 10.9917 2.4082 12.1667C3.06654 13.2 3.8332 14.0917 4.66654 14.8083",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0166 16.2751C7.9666 16.6751 8.9749 16.8917 9.9999 16.8917C12.9416 16.8917 15.6832 15.1584 17.5916 12.1584C18.3416 10.9834 18.3416 9.00841 17.5916 7.83337C17.3166 7.40003 17.0166 6.9917 16.7082 6.60837",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.925 10.5833C12.7083 11.7583 11.75 12.7167 10.575 12.9333",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89175 12.1083L1.66675 18.3333",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 1.66667L12.1084 7.89167",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.60df9112928d90b994809faca38603ce.svg";
export { ForwardRef as ReactComponent };